import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class RmColumnsDTO {
    static columnsNo(columnsCode: any, columnsNo: any, pouchesPerRow: any) {
        throw new Error('Method not implemented.');
    }
    @ApiProperty()
    @IsOptional()
    columnsId?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Code not be empty" })
    columnsCode: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    columnsNo: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    isActive: boolean;


    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    createdUser: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    updatedUser: string;


}